import React, { useState } from 'react'
import {
  Card,
  Table,
  Button,
  Input,
  Divider,
  Collapse,
  Row,
  Col,
  Modal,
  Form,
  Tooltip,
  message,
  Pagination
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import SupplierImg from '../../../assets/images/suppliers.png'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { SUPPLIER } from '../../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  notAllowMsgCheck
} from '../../../appRedux/actions/GlobalMethods'
import { userLogOut } from '../../../appRedux/actions/Auth'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
// import { REACT_APP_BUS_FIRST_NAME } from '../../../constants/StoreSetting'
import { env } from '../../../env'
const Panel = Collapse.Panel
const confirm = Modal.confirm
const { REACT_APP_BUS_FIRST_NAME } = env

const Suppliers = ({ match }) => {
  const [visible, setVisible] = React.useState(false)
  const history = useHistory()
  const dispatch = useDispatch()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [getTableData, setTableData] = React.useState([])
  const [getIsLoading, setIsLoading] = React.useState(true)
  const [getPagination, setPagination] = React.useState({
    current: 1,
    pageSize: 10
  })

  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(SUPPLIER))
      let body = { CurrentPageNo: getPagination.current }
      getSuppliersData(body)
    }

    return () => (mounted = false)
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  const redirectToadd = () => {
    history.push('/Dashboard/products/supplier/add')
  }

  async function getSuppliersData (body) {
    setIsLoading(true)
    const getSuppliers = ds.getSuppliers(body, BEHAVIOUR_TYPE.GET)
    await getSuppliers
      .then(response => {
        if (response.data.data != null) {
          let mapped = response.data.data.map(supplier => {
            return {
              key: supplier.supplierID,
              name: supplier.supplierName,
              description: supplier.supplierDescription,
              defmarkup: supplier.defaultMarkupPercentage,
              numofproducts: supplier.noOfProducts,
              supplierIDEncyp: supplier.supplierIDEncrypted
            }
          })

          // mapped.sort((a, b) => (a.name > b.name ? 1 : -1));

          setTableData(mapped)
          setIsLoading(false)
          let paginationObj = {
            current: body.CurrentPageNo,
            pageSize: getPagination.pageSize,
            total:
              response.data.data.length > 0
                ? response.data.data[0].totalRecords
                : 0
          }
          setPagination(paginationObj)
        }
      })
      .catch(e => {
        notAllowMsgCheck(e)
      })
  }
  const handleTableChange = (pagination, filters, sorter) => {
    let body = { CurrentPageNo: pagination.current }
    getSuppliersData(body)
  }

  const columns = [
    {
      title: <IntlMessages id='products.suppliers.name' />,
      key: 'name',
      render: (text, record) => (
        <span>
          <a
            href={'/Dashboard/products/supplier/view/' + record.key}
            className='gx-link'
          >
            {record.name}
          </a>
        </span>
      )
    },
    {
      title: <IntlMessages id='products.suppliers.description' />,
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: <IntlMessages id='products.suppliers.defaultmarkup' />,
      dataIndex: 'defmarkup',
      key: 'defmarkup'
    },
    {
      title: <IntlMessages id='products.suppliers.noofproducts' />,
      dataIndex: 'numofproducts',
      key: 'numofproducts'
    },
    {
      title: <IntlMessages id='products.suppliers.view' />,
      key: 'view',
      render: (text, record) => (
        <span>
          <a
            href={`/dashboard/products/main/listing/supplierid/${record.supplierIDEncyp}`}
            className='gx-link'
          >
            <IntlMessages id='products.suppliers.viewproducts' />
          </a>
        </span>
      )
    },
    {
      title: <IntlMessages id='products.suppliers.edit' />,
      key: 'edit',
      render: (text, record) => (
        <span>
          <a
            onClick={() => {
              history.push(`/Dashboard/products/supplier/edit/${record.key}`)
            }}
            className='pen-edit'
          >
            <i className='icon icon-edit'> </i>
          </a>
        </span>
      )
    },
    {
      title: <IntlMessages id='products.suppliers.delete' />,
      key: 'delete',
      render: (text, record) => {
        const deleteSupplier = async supplierID => {
          let addUpdateDeleteSupplier = {
            data: {
              msgCode: '',
              msgDescription: ''
            }
          }
          await ds
            .addUpdateDeleteSupplier(
              {
                SupplierID: supplierID,
                IsRemove: true
              },
              BEHAVIOUR_TYPE.DELETE
            )
            .then(response => (addUpdateDeleteSupplier.data = response.data))
            .catch(e => {
              notAllowMsgCheck(e)
            })

          if (addUpdateDeleteSupplier.data.msgCode == 'GENERAL_SUCCESS') {
            // message.success(addUpdateDeleteSupplier.data.msgDescription, 2)
            message.success("Supplier deleted successfully !")
            setTimeout(() => {
              window.location.href = '/Dashboard/products/Supplier/listing'
            }, 1000)
          }

          if (addUpdateDeleteSupplier.data.msgCode == 'GENERAL_ERROR') {
            message.error(addUpdateDeleteSupplier.data.msgDescription)
          }
        }

        function showDeleteConfirm (supplierID, supplierName) {
          confirm({
            title: 'Are you sure delete this Supplier?',
            content: `"${supplierName}"`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: { className: 'dk-btn-add close-reg-btn' },
            cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
            onOk () {
              deleteSupplier(supplierID)
            },
            onCancel () {
              //console.log('Cancel');
            }
          })
        }


        return (
          <span>
            <a
                onClick={() => showDeleteConfirm(record.key, record.name)}
              className='trash-icon-btn'
            >
              {' '}
              <i className='icon icon-trash' />
            </a>
          </span>
        )
      }
    }
  ]
  return (
    <div className='Content-wrapper Suppliers-pg'>

       <Row className="align-items-center justify-content-center mb-3 ProductTypes-header">
       <Col lg={12} md={12} sm={24} xs={24}>
        <h1 className="mb-0">
            <IntlMessages id='products.suppliers.suppliers' />
          </h1>
        </Col>
        <Col lg={12} md={12} sm={24} xs={24}>
         <div className="pg-header-btn">
            <Button className='dk-btn-add' type='primary' onClick={redirectToadd} size='large'>
              <IntlMessages id='products.suppliers.addsupplier' />
            </Button>
          </div>
        </Col>
      </Row>

      <Card className='gx-card' title=''>
        <Collapse>
          <Panel
            className='custom-promolist-help'
            showArrow={false}
            header={
              <IntlMessages id='products.suppliers.needhelpheadingsupplier' />
            }
          >
            <Row>
              <div className='billing-main'>
                <Col className='custom-promolist-helpdesc' md={12}>
                  <p>
                    <IntlMessages id='products.suppliers.needhelpheadingsupplierpdescription1' />
                  </p>
                  <p>
                    <IntlMessages
                      id='products.suppliers.needhelpheadingsupplierpdescription2'
                      values={{
                        strong: chunks => <strong>{chunks}</strong>,
                        bus_name_first: REACT_APP_BUS_FIRST_NAME
                      }}
                    />
                  </p>
                  <p>
                    <IntlMessages id='products.suppliers.needhelpheadingsupplierpdescription3' />
                  </p>
                </Col>

                <Col md={12}>
                  <img src={SupplierImg} alt='' />
                </Col>
              </div>
            </Row>
          </Panel>
        </Collapse>
      </Card>

      <div className='tab-body-parent'>
        <Card>
          {getIsLoading ? (
            <Skeleton count={5} height={30} />
          ) : (
            <>
              {' '}
              <Table
                className='gx-table-responsive'
                columns={columns}
                dataSource={getTableData}
                pagination={getPagination}
                onChange={handleTableChange}
              />
            </>
          )}
        </Card>
      </div>
    </div>
  )
}

export default Suppliers
